const timeAxis = () => import("@/components/common/timeAxis/Index.vue");
import * as clipWork from "./map2.js";
import { clipPositions } from "@/components/tables/planClip/clipData.js";
import * as photoGraphic from "@/components/common/photoGraphic/map.js";

export default {
  components: {
    timeAxis,
  },
  data() {
    return {
      clipModelId: "NewNode-edaac84f-5019-48b3-84fd-57713ef6def6",
      childId: window.sessionStorage.getItem("childId"),
      marks: {
        0: "开始",
        // 200: "进度一",
        // 350: "进度二",
        // 400: "进度三",
        // 550: "进度四",
        // 680: "进度五",
        // 790: "进度六",
        // 880: "进度七",
        // 1000: "进度八",
        // 1180: "进度九",
        // 1250: "进度十",
        // 1350: "进度十一",
        1470: "结束",
        // 120: "进度五",
        // 152: "进度五",
        // 182: "进度七",
        // 210: "进度六",
        // 244: "进度九",
        // 274: "进度七",
        // 305: "进度十一",
        // 366: "结束",
      },
      flightData: {
        alt: 617.8,
        heading: 329.2,
        lat: 24.81834086,
        lng: 118.53442309,
        pitch: -41.5,
      },
    };
  },
  methods: {
    playpause(type) {},
    watchValue(v) {
      if (clipPositions[v] && clipPositions[v] != undefined) {
        let tilesetLayer = this.$GLOBAL.map.getLayer(
          this.clipModelId,
          "modelId"
        );
        if (tilesetLayer) {
          clipWork.addPlanClipThing(this.clipModelId, clipPositions[v]);
        }
      } else {
        console.log(v);
      }
    },
    redo() {
      console.log("重置");
      clipWork.addPlanClipThing(this.clipModelId, clipPositions[0]);
    },
    keyFrameFn(e) {
      // console.log(e);
    },
    timeInput(e) {
      // console.log(e);
    },
    // sliderValChange(val) {
    //   let multiplier = 1 / this.sliderStep;
    //   let index = parseInt(val * multiplier);
    //   if (clipPositions[index] && clipPositions[index] != undefined) {
    //     clipWork.addPlanClipThing(this.childId, clipPositions[index]);
    //   } else {
    //     console.log(index);
    //   }
    // },
  },
  mounted() {
    photoGraphic.flight(this.flightData, null, (e) => {});
  },
  destroyed() {},
  watch: {},
};
